import { Prospecto } from './prospecto.model';
import { Contratante, Conductor, Vehiculo } from './data-emision.model';
import { DatosCotizacion} from './datos-cotizacion.model';
import { Encrypted } from '../Constants/configuration';
import { CSUrls } from '../Constants/cs-urls';

export class CocheSeguro {
    public ntf:boolean;
    public dominioMkp:string;
    public a:string;
    public m:string;
    public url?:string;
    public tkn?:string;
    public cot_id?:number;
    public cia?:number;
    public clEnt?:string;
    public cli?:number;
    public formaPago?:string;
    public dcl?:number;
    public prospecto?:Prospecto;
    public contratante?:Contratante;
    public dataVehiculo?:DatosCotizacion;
    public conductor?:Conductor;
    public vehiculo?:Vehiculo;
    public bdmock?:any[];
    public cotizacionZurich?:{
        contact_birth_date: string,
        quote_id: string,
        paqueteDescripcionZurich: string,
        descripcion: string,
        prima_total: string,
        desglocePrimas: {
            rec_ini: string
        }
    };
    public telefono?:string;
    public paquete?:number;
    public celular?:string;
    public grupoID:number= (window.location.hostname === CSUrls.CS_SIVALE) ? 2075 : 2080 ;    
    public fecCotizacion?: string = "";
    public grupoIDSecundario:number =(window.location.hostname=== CSUrls.INTER ? 0 :
        window.location.hostname=== CSUrls.CS_EMPLEADOS ? 2081 :
        window.location.hostname=== CSUrls.UVM ? 2082 :
        window.location.hostname=== CSUrls.UNITEC ? 2083 :
        window.location.hostname=== CSUrls.CS_1 ? 2089 : //izzi
        window.location.hostname=== CSUrls.WALDOS ? 2090 :
        window.location.hostname=== CSUrls.UAG ? 2091 :
        window.location.hostname=== CSUrls.AS_DEPORTE ? 2092 :
        window.location.hostname=== CSUrls.INTER_SECURITAS ? 2104 :
        window.location.hostname=== CSUrls.UNIFIN_EMPLEADOS ? 2105 :
        window.location.hostname=== CSUrls.UNIFIN ? 2106 :
        window.location.hostname=== CSUrls.SELLER ? 2114 :
        window.location.hostname=== CSUrls.LOTTUS ? 2115 :
        window.location.hostname === CSUrls.CLUB_PREMIER ? 482:
        window.location.hostname=== CSUrls.STONE ? 2117 : (0) );
    public isNomina:boolean = window.location.hostname=== CSUrls.CS_EMPLEADOS ||
    window.location.hostname=== CSUrls.UNIFIN_EMPLEADOS ||
    window.location.hostname=== CSUrls.SELLER ||
    window.location.hostname=== CSUrls.INTER_SECURITAS ? true : false;
    public origen:number = (window.location.hostname=== CSUrls.INTER ?1:
    window.location.hostname=== CSUrls.CS_SIVALE ? 18 :
    window.location.hostname=== CSUrls.MANPOWER ? 21 :
    window.location.hostname === CSUrls.CLUB_PREMIER ? 20 :
    window.location.hostname=== CSUrls.CS_EMPLEADOS ? 2 :
    window.location.hostname=== CSUrls.UNITEC ? 3 :
    window.location.hostname=== CSUrls.UVM ? 4 :
    window.location.hostname=== CSUrls.CS_1 ? 5 :
    window.location.hostname=== CSUrls.WALDOS ? 6 :
    window.location.hostname=== CSUrls.UAG ? 7 :
    window.location.hostname=== CSUrls.AS_DEPORTE ? 8 :
    window.location.hostname=== CSUrls.INTER_SECURITAS ? 9 :
    window.location.hostname=== CSUrls.UNIFIN_EMPLEADOS ? 10 :
    window.location.hostname=== CSUrls.UNIFIN ? 11 :
    window.location.hostname=== CSUrls.SELLER ? 14 :
    window.location.hostname=== CSUrls.LOTTUS ? 15 :
    window.location.hostname === CSUrls.CLUB_PREMIER ? 20:
    window.location.hostname === CSUrls.CENEGAS ? 24:
    window.location.hostname=== CSUrls.STONE ? 16 : (1) );
    public polizaIdEnc?:string;
    public polizaId?:number;
    public opcion?:number;
    public clEntInt?:string;
    public edad?: number = 18;
    public sexo?: boolean = true;
    public isVisibleProteccionAdicional: boolean = (window.location.hostname=== CSUrls.INTER  || CSUrls.INTER_QA ? true :
    window.location.hostname=== CSUrls.CS_EMPLEADOS ? true :
    window.location.hostname=== CSUrls.UVM ? true :
    window.location.hostname=== CSUrls.UNITEC ? true :
    window.location.hostname=== CSUrls.CS_1 ? true : //izzi
    window.location.hostname=== CSUrls.WALDOS ? true :
    window.location.hostname=== CSUrls.CS_1 ? true :
    window.location.hostname=== CSUrls.AS_DEPORTE ? true :
    window.location.hostname=== CSUrls.INTER_SECURITAS ? true :
    window.location.hostname=== CSUrls.UNIFIN_EMPLEADOS ? false :
    window.location.hostname=== CSUrls.UNIFIN ? false :
    window.location.hostname=== CSUrls.SELLER ? true :
    window.location.hostname=== CSUrls.LOTTUS ? true :
    window.location.hostname=== CSUrls.STONE ? true : false);
    public estructuraGrupoId:number = (window.location.hostname=== CSUrls.INTER ? 1 :
    window.location.hostname=== CSUrls.CS_EMPLEADOS ? 11 :
    window.location.hostname=== CSUrls.UVM ? 2 :
    window.location.hostname=== CSUrls.UNITEC ? 3 :
    window.location.hostname=== CSUrls.CS_1 ? 4 :
    window.location.hostname=== CSUrls.CS_SIVALE ? 5 :
    window.location.hostname=== CSUrls.MANPOWER ? 25 :
    window.location.hostname=== CSUrls.WALDOS ? 19 :
    window.location.hostname=== CSUrls.UAG ? 1 :
    window.location.hostname=== CSUrls.AS_DEPORTE ? 1 :
    window.location.hostname=== CSUrls.INTER_SECURITAS ? 16 :
    window.location.hostname=== CSUrls.UNIFIN_EMPLEADOS ? 14 :
    window.location.hostname=== CSUrls.UNIFIN ? 13 :
    window.location.hostname=== CSUrls.SELLER ? 10 :
    window.location.hostname=== CSUrls.LOTTUS ? 17 :
    window.location.hostname=== CSUrls.CENEGAS ? 31 :
    window.location.hostname === CSUrls.CLUB_PREMIER ? 20:
    window.location.hostname=== CSUrls.STONE ? 18 : (1) );
    public urlVerWeb:string = '';
    public correoEnviadoFE:boolean; //Bandera que indica si ya fue enviado un correo a fuerza elite con el logConsumo actual
    public templateCotizacionPdf: string = (window.location.hostname=== CSUrls.UVM ? new Encrypted().SESENTAYTRES :
      window.location.hostname=== CSUrls.UNITEC ? new Encrypted().SESENTAYCUATRO : new Encrypted().CUARENTAYCINCO);
}